import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import CardGrid from '@stories/Components/CardGrid/CardGrid';
import SignpostCardStyles from '@stories/Components/Cards/SignpostCard/SignpostCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import TitleAndIntroductionStyles from '@stories/Components/Misc/TitleAndIntroduction/TitleAndIntroduction.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${TitleAndIntroductionStyles.Container} {
    margin-bottom: ${fluid(24, 48)};
  }

  ${TitleAndIntroductionStyles.Introduction} {
    margin-bottom: 0;
  }

  /* Override the columns */
  ${TitleAndIntroductionStyles.Container}[data-alignment='left'] {
    ${TitleAndIntroductionStyles.Title},
    ${TitleAndIntroductionStyles.Introduction} {
      @media ${from(Device.TabletLarge)} {
        grid-column: 1 / span 6;
      }
    }
  }
`;
const Wrapper = styled.div ``;
const FourColGrid = styled(CardGrid) `
  [data-has-carousel='true'] & {
    --itemPeek: 80px;
  }

  @media ${from(Device.MobileLarge)} {
    --rowItems: 2 !important; // Important required to prevent CLS specificity issue

    [data-alignment='left'] & {
      --alignment: flex-start;
    }
  }

  @media ${from(Device.TabletLarge)} {
    --rowItems: 3 !important;
  }

  @media ${from(Device.DesktopSmall)} {
    --rowItems: 4 !important;
    --maxWidth: 33%;
  }

  /* If any of the cards contains an image or icon, ensure the content areas are the same size */
  &:has(${SignpostCardStyles.ImageContainer} img, ${SignpostCardStyles.ImageContainer} svg) {
    ${SignpostCardStyles.ContentWrapper} {
      flex: 1;
      margin-top: 0;
    }
  }
`;
const Signpoststyles = {
    Container,
    Wrapper,
    FourColGrid,
};
export default Signpoststyles;
